(() => {
  const DELIVERY_REGIONS = new Map([
    ['AL', ['South & Southeast', '2–4 business days']], ['AR', ['South & Southeast', '2–4 business days']],
    ['FL', ['South & Southeast', '2–4 business days']], ['GA', ['South & Southeast', '2–4 business days']],
    ['KY', ['South & Southeast', '2–4 business days']], ['LA', ['South & Southeast', '2–4 business days']],
    ['MS', ['South & Southeast', '2–4 business days']], ['NC', ['South & Southeast', '2–4 business days']],
    ['SC', ['South & Southeast', '2–4 business days']], ['TN', ['South & Southeast', '2–4 business days']],
    ['TX', ['South & Southeast', '2–4 business days']], ['VA', ['South & Southeast', '2–4 business days']],
    ['WV', ['South & Southeast', '2–4 business days']],
    ['IL', ['Midwest & Plains', '2–4 business days']], ['IN', ['Midwest & Plains', '2–4 business days']],
    ['IA', ['Midwest & Plains', '2–4 business days']], ['KS', ['Midwest & Plains', '2–4 business days']],
    ['MI', ['Midwest & Plains', '2–4 business days']], ['MO', ['Midwest & Plains', '2–4 business days']],
    ['NE', ['Midwest & Plains', '2–4 business days']], ['ND', ['Midwest & Plains', '2–4 business days']],
    ['OH', ['Midwest & Plains', '2–4 business days']], ['OK', ['Midwest & Plains', '2–4 business days']],
    ['SD', ['Midwest & Plains', '2–4 business days']],
    ['ME', ['Northeast', '3–4 business days']], ['MD', ['Northeast', '3–4 business days']],
    ['NH', ['Northeast', '3–4 business days']], ['PA', ['Northeast', '3–4 business days']],
    ['AZ', ['Mountain & Southwest', '3–5 business days']], ['MT', ['Mountain & Southwest', '3–5 business days']],
    ['NV', ['Mountain & Southwest', '3–5 business days']], ['NM', ['Mountain & Southwest', '3–5 business days']],
    ['UT', ['Mountain & Southwest', '3–5 business days']], ['WY', ['Mountain & Southwest', '3–5 business days']],
  ]);

  const showMessage = (result, title, message, type = '') => {
    result.replaceChildren();
    const strong = document.createElement('strong');
    strong.className = 'dc-shipping-estimator__result-title';
    strong.textContent = title;
    const text = document.createElement('span');
    text.textContent = message;
    result.append(strong, text);
    result.className = `dc-shipping-estimator__result is-visible${type ? ` is-${type}` : ''}`;
  };

  const initializeEstimator = (estimator) => {
    if (estimator.dataset.initialized === 'true') return;
    estimator.dataset.initialized = 'true';

    const form = estimator.querySelector('[data-shipping-estimator-form]');
    const result = estimator.querySelector('[data-shipping-estimator-result]');
    if (!form || !result) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const deliveryRegion = DELIVERY_REGIONS.get(form.elements.province.value);

      if (!deliveryRegion) {
        showMessage(
          result,
          'Shipping is not currently available',
          'BG Reveals cannot currently be shipped to the selected state. Please review the eligible-state list below.',
          'error'
        );
        return;
      }

      const [region, timeline] = deliveryRegion;
      showMessage(
        result,
        `Estimated arrival: ${timeline}`,
        `${region} estimate, including one business day for order handling and ground transit. Final availability and timing are confirmed at checkout.`,
        'success'
      );
    });
  };

  const initializeAllEstimators = (scope = document) => {
    scope.querySelectorAll('[data-daylight-shipping-estimator]').forEach(initializeEstimator);
  };

  initializeAllEstimators();
  document.addEventListener('shopify:section:load', (event) => initializeAllEstimators(event.target));
})();
